import "./index.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainPage from "./components/MainPage";
import AboutUs from "./components/AboutUs";
import CaseStudy from "./components/CaseStudy";
import CaseStudy1 from "./components/Case-Studies/caseStudy1";
import CaseStudy2 from "./components/Case-Studies/caseStudy2";
import CaseStudy3 from "./components/Case-Studies/caseStudy3";
import CaseStudy4 from "./components/Case-Studies/caseStudy4";
import CaseStudy5 from "./components/Case-Studies/caseStudy5";
import CaseStudy6 from "./components/Case-Studies/caseStudy6";
import CaseStudy7 from "./components/Case-Studies/caseStudy7";
import CaseStudy8 from "./components/Case-Studies/caseStudy8";
import CaseStudy9 from "./components/Case-Studies/caseStudy9";
import CaseStudy10 from "./components/Case-Studies/caseStudy10";
import CaseStudy11 from "./components/Case-Studies/caseStudy11";
import CaseStudy12 from "./components/Case-Studies/caseStudy12";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/CaseStudy" element={<CaseStudy />} />
        <Route path="/case-study1" element={<CaseStudy1 />} />
        <Route path="/case-study2" element={<CaseStudy2 />} />
        <Route path="/case-study3" element={<CaseStudy3 />} />
        <Route path="/case-study4" element={<CaseStudy4 />} />
        <Route path="/case-study5" element={<CaseStudy5 />} />
        <Route path="/case-study6" element={<CaseStudy6 />} />
        <Route path="/case-study7" element={<CaseStudy7 />} />
        <Route path="/case-study8" element={<CaseStudy8 />} />
        <Route path="/case-study9" element={<CaseStudy9 />} />
        <Route path="/case-study10" element={<CaseStudy10 />} />
        <Route path="/case-study11" element={<CaseStudy11 />} />
        <Route path="/case-study12" element={<CaseStudy12 />} />
        {/* Define other routes here */}
      </Routes>
    </Router>
  );
}

export default App;
